<!--
Created on 2021-04-19
Copyright (c) 2021 Vilten s.r.o. - All Rights Reserved
Unauthorized copying of this file, via any medium is strictly prohibited
Proprietary and confidential
Written by Viliam Tencer <vilten@vilten.sk>, 2021-04-19
-->
<template>
  <div id="modal-sync" class="menu menu-box-modal rounded-m" 
      data-menu-height="280"
      data-menu-width="310">
    <h1 class="text-center mt-4 font-700">{{ title }}</h1>
    <p class="boxed-text-l mb-3">
      Momentálne prebieha synchronizácia so servermi Dr Theiss.
    </p>
    <div class="px-4">
      <div class="progress rounded-sm shadow-xl border border-fade-green-dark" style="height:28px">
        <div class="progress-bar bg-green-dark text-start ps-3 color-white" 
            role="progressbar" :style="{ width: progress + '%' }"
            aria-valuenow="10" aria-valuemin="0" 
            aria-valuemax="100">
          {{ progress }}% Dokončené
        </div>
      </div>
      <p v-if="!errorMessage" class="boxed-text-l mb-2 font-10">
        {{ message }}
      </p>
      <p v-if="errorMessage" class="boxed-text-l color-red-dark mb-2 font-10">
        {{ errorMessage }}
      </p>
      <div class="row px-4">
        <button @click="closeModal(true);" class="btn btn-m mt-2 btn-full bg-highlight rounded-sm text-uppercase font-900" :disabled="syncLoading"><i v-if="syncLoading" class="fa fa-sync fa-spin me-3"></i>Zavrieť</button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, inject } from 'vue'
import asyncAPI from '@/lib/async'

export default {
  name: 'SyncModal',
  setup(props, context) {
    const title = ref('Synchronizácia')
    const progress = ref(0)
    const errorMessage = ref('')
    const message = ref('...')
    const syncLoading = ref(false)
    const noUpload = ref(false)

    const appProps = inject('appProps')

    function closeModal (error) {
      appProps.$hideSyncModal()
      if (!error) context.emit('onFinish', noUpload.value)
    }

    function stepSync (stepNumber) {
      let step = stepNumber ?? 0
      progress.value = Math.floor(step * (100 / 5))
      step++
      switch (step) {
        case 1:
          setTimeout(() => {
            message.value = 'Sťahuje sa práve: "Zákazníci"'
            asyncAPI.downloadCustomers()
              .then(customers => {
                window.localStorage.setItem('customers', JSON.stringify(customers))
                stepSync(step)
              })
              .catch(() => {
                message.value = ''
                errorMessage.value = "Nastala chyba pri sťahovaní."
                syncLoading.value = false
              })
          }, 100)
          break
        case 2:
          setTimeout(() => {
            message.value = 'Sťahuje sa práve: "Zákazníci"'
            asyncAPI.downloadCustomers()
              .then(customers => {
                window.localStorage.setItem('customers', JSON.stringify(customers))
                stepSync(step)
              })
              .catch(() => {
                message.value = ''
                errorMessage.value = "Nastala chyba pri sťahovaní."
                syncLoading.value = false
              })
          }, 100)
          break
        case 3:
          setTimeout(() => {
            message.value = 'Sťahuje sa práve: "Zákazníci"'
            asyncAPI.downloadCustomers()
              .then(customers => {
                window.localStorage.setItem('customers', JSON.stringify(customers))
                stepSync(step)
              })
              .catch(() => {
                message.value = ''
                errorMessage.value = "Nastala chyba pri sťahovaní."
                syncLoading.value = false
              })
          }, 100)
          break
        case 4:
          setTimeout(() => {
            message.value = 'Sťahuje sa práve: "Zákazníci"'
            asyncAPI.downloadCustomers()
              .then(customers => {
                window.localStorage.setItem('customers', JSON.stringify(customers))
                stepSync(step)
              })
              .catch(() => {
                message.value = ''
                errorMessage.value = "Nastala chyba pri sťahovaní."
                syncLoading.value = false
              })
          }, 100)
          break
        case 5:
          setTimeout(() => {
            message.value = 'Sťahuje sa práve: "Zákazníci"'
            // errorMessage.value = "Nastala chyba pri sťahovaní."
            stepSync(step)
          }, 500)
          break
        default:
          setTimeout(() => {
            message.value = noUpload.value ? 'Inicializácia bola úspešne dokončená.' : 'Synchronizácia bola úspešne dokončená.'
            closeModal()
            syncLoading.value = false
          }, 500)
      }
    }

    function startSync (initDb) {
      noUpload.value = initDb === true
      if (initDb) {
        title.value = 'Inicializácia'
        message.value = 'Inicializácia štartuje.'
      } else {
        title.value = 'Synchronizácia'
        message.value = 'Synchronizácia štartuje.'
      }
      process.value = 0
      errorMessage.value = ''
      syncLoading.value = true
      setTimeout(() => {
        stepSync()
      }, 500)
    }

    return {
      title,
      noUpload,
      syncLoading,
      errorMessage,
      message,
      startSync,
      closeModal,
      stepSync,
      progress,
    }
  },
}
</script>
